import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngxs/store';
import { TermsService } from '../../../../_services';
import { HelperService } from './../../../../../../../_shared/services/helper.service';
import { MfToastService } from './../../../../../../../_shared/services/mfToast.service';
import { StorageService } from './../../../../../../../_shared/services/storage.service';
import { DocumentViewerComponent } from './../../../../../../basic-components/document-viewer/document-viewer.component';
import { DocumentViewerService } from './../../../../../../basic-components/document-viewer/document-viewer.service';
import { TelemedicineService } from './../../../../../telemedicine/telemedicine.service';
import { ConfigGUIService } from './../../../../_services/configGUI.service';
import { DocumentsService } from './../../../../_services/documents.service';

@Component({
    selector: 'trt-wid-m-documents',
    templateUrl: './trt-wid-m-documents.component.html',
    styleUrls: ['./trt-wid-m-documents.component.scss'],
})
export class TrtWidMDocumentsComponent extends DocumentViewerComponent implements OnInit {
    @Input()
    noteId: number;

    constructor(
        public fb: FormBuilder,
        public helper: HelperService,
        public mfToast: MfToastService,
        public docviewRest: DocumentsService,
        public storage: StorageService,
        public configGUIRest: ConfigGUIService,
        public wscs: TelemedicineService,
        public dvs: DocumentViewerService,
        public store: Store,
        public termsService: TermsService,
    ) {
        super(fb, helper, mfToast, docviewRest, termsService, storage, configGUIRest, wscs, dvs, store);
    }

    ngOnInit() {
        super.ngOnInit();
    }
}
